import {
    GET_REGIONS_REQUEST,
    GET_REGIONS_SUCCESS,
    GET_REGIONS_FAILURE,
    POST_REGIONS_SUCCESS,
    ADD_PREVIEW_REGIONS,
    REMOVE_PREVIEW_REGIONS

} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    data: [],
    error: null,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_REGIONS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_REGIONS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.regions,
                isInitialFetch: false,
            };
        case GET_REGIONS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        case ADD_PREVIEW_REGIONS: {
            const newRegions = action.payload.regions.map((d) => ({ ...d, isDisabled: true, csvUploaded: true }));
            return {
                ...state,
                data: [...newRegions, ...state.data],
            };
        }

        case REMOVE_PREVIEW_REGIONS: {
            return {
                ...state,
                data: state.data.filter((f) => !f.isDisabled && !f.csvUploaded),
            };
        }
        case POST_REGIONS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.regions,
                isInitialFetch: false,
            };
        default:
            return state;
    }
};